import React, { useState, useEffect, useMemo, useRef } from 'react'
import cx from 'classnames'
import vsbl from 'vsbl'

import { createSerializer } from 'src/utils/serializer'
import { StandardTextProps } from 'src/components/global/interfaces/StandardText'
import BlockContent from './BlockContent'
import moduleProps from 'src/utils/moduleProps'
import { getPortableTextHeading } from 'src/utils/ctaTracking'

export const StandardText = ({ data }: { data: StandardTextProps }) => {
  const {
    text,
    backgroundColor,
    spacing,
    containerSize,
    deepLinkId,
    options,
  } = data
  const dom = useRef<HTMLDivElement>(null)
  const [className, setClass] = useState('')
  const serializers = useMemo(
    () => createSerializer({ module: 'Standard text module', heading: getPortableTextHeading(text, 'Standard text') }),
    [text]
  )

  useEffect(() => {
    const { current } = dom
    const vs = vsbl(current)(() => {
      setClass('is-visible')
    })
    vs.update()
  }, [0])

  return (
    <div
      id={deepLinkId || options?.uid}
      ref={dom}
      className={cx(backgroundColor, className, spacing, {
        cw: backgroundColor === 'bcb',
      })}
      {...moduleProps(data)}
    >
      <div className="container--l outer opacity slide-up d2 animate mxa standard__text py2 px1 al x">
        <div className={cx(containerSize, 'standard__text-content')}>
          <BlockContent
            blocks={text}
            serializers={serializers}
          />
        </div>
      </div>
    </div>
  )
}
